"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapStateToProps = exports["default"] = exports.AssetGroupDualList = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _reselect = require("reselect");

var _commonDualList = _interopRequireDefault(require("./common-dual-list"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getAssetGroups = function getAssetGroups(state) {
  var _state$assetInformati;

  return ((_state$assetInformati = state.assetInformationLists) === null || _state$assetInformati === void 0 ? void 0 : _state$assetInformati.assetGroups) || [];
};

var assetGroupSelector = (0, _reselect.createSelector)(getAssetGroups, function (groups) {
  return groups.map(function (_ref) {
    var id = _ref.id,
        name = _ref.name;
    return {
      id: id,
      label: name
    };
  });
});

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var mappedProps = {
    assetGroups: assetGroupSelector(state)
  };

  if (ownProps !== null && ownProps !== void 0 && ownProps.useAssetGroupsInParams) {
    var _ownProps$assetGroups;

    mappedProps.assetGroups = (_ownProps$assetGroups = ownProps.assetGroups) === null || _ownProps$assetGroups === void 0 ? void 0 : _ownProps$assetGroups.map(function (asset) {
      return {
        id: asset.id,
        label: asset.name
      };
    });
  }

  return mappedProps;
};

exports.mapStateToProps = mapStateToProps;

var AssetGroupDualList = function AssetGroupDualList(_ref2) {
  var assetGroups = _ref2.assetGroups,
      selectedAssetGroups = _ref2.selectedAssetGroups,
      allAssetGroupsSelected = _ref2.allAssetGroupsSelected,
      _onChange = _ref2.onChange;
  return /*#__PURE__*/_react["default"].createElement(_nicbaseForms.KasasiSectionHeader, {
    icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.AssetGroup, null),
    title: /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "duallist.assetGroups",
      tagName: "span"
    })
  }, /*#__PURE__*/_react["default"].createElement(_commonDualList["default"], {
    items: assetGroups,
    allItemsSelected: allAssetGroupsSelected,
    selectedItems: selectedAssetGroups,
    onChange: function onChange(_ref3) {
      var allItemsSelected = _ref3.allItemsSelected,
          selectedItems = _ref3.selectedItems;
      return _onChange({
        allAssetGroupsSelected: allItemsSelected,
        selectedAssetGroups: selectedItems
      });
    }
  }));
};

exports.AssetGroupDualList = AssetGroupDualList;
AssetGroupDualList.propTypes = {
  allAssetGroupsSelected: _propTypes["default"].bool,
  assetGroups: _propTypes["default"].arrayOf(_propTypes["default"].shape()),
  selectedAssetGroups: _propTypes["default"].arrayOf(_propTypes["default"].number),
  onChange: _propTypes["default"].func
};
AssetGroupDualList.defaultProps = {
  allAssetGroupsSelected: true,
  assetGroups: [],
  selectedAssetGroups: [],
  onChange: function onChange() {}
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(AssetGroupDualList);

exports["default"] = _default;